"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const index_1 = tslib_1.__importDefault(require("./index"));
exports.default = (props) => {
    const { input, input: { value }, meta: { error, touched }, options, multiple } = props, restProps = tslib_1.__rest(props, ["input", "input", "meta", "options", "multiple"]);
    return (React.createElement(index_1.default, Object.assign({}, input, { onBlur: () => {
            input.onBlur(value);
        }, onFocus: input.onFocus, multiple: multiple, value: input.value ? input.value : multiple ? [] : null, error: touched && error ? error : undefined, options: options }, restProps)));
};
